module.exports = __webpack_public_path__ + "media/images/icon-document-60ce916f4183695b45ff14d493c88d65.svg";